// * If not native then we do not use Firebase.

const FirebaseContainer = (props) => {
    return (
        <></>
    )
}

export default FirebaseContainer